'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';
import { mapRecruitmentDetailToView } from '../components/seedingDetail/adapters';

/**
 * 시딩 모집형 상세 — service DTO 를 `select` 단계에서 presentation `SeedingCampaignDetail` 로 매핑.
 * 페이지는 매핑 결과(`data`)를 PageView 에 그대로 주입한다.
 */
export const useSeedingRecruitmentDetail = (campaignId: number | undefined) =>
  useQuery({
    ...curatorQueries.campaigns.seedingRecruitmentDetail({ campaignId: campaignId! }),
    enabled: campaignId !== undefined && campaignId > 0,
    select: mapRecruitmentDetailToView,
  });
